import React, { Component } from 'react'
import ConfirmationOfEnrolmentReport from '../tags/reports/ConfirmationOfEnrolmentReport'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { putStudentReport } from '../../services/vu'
import PublicTransportVictoriaReport from '../tags/reports/PublicTransportVictoriaReport'
import { fetchPersonalDataIfNeeded } from '../../actions/personalDetails'

const mapStateToProps = ({ courses: { selectedCourseCode, data }, course: { selectedCourse }, personalDetails, currentUser }) => {
  return {
    course: selectedCourse,
    courseCode: selectedCourseCode,
    personalDetails: personalDetails.data,
    userRole: currentUser.data['role']
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchPersonalDetails: () => {
      dispatch(fetchPersonalDataIfNeeded())
    }
  }
}

class Reports extends Component {
  constructor(props, context) {
    super(props, context)

    this.state = {
      reportType: this.props.match.params.reportType,
      year: new Date().getFullYear(),
      submitting: false
    }
  }

  componentDidMount() {
    if (this.props.userRole == 'STUDENT') {
      this.props.fetchPersonalDetails()
    }
  }

  handleFormCancel = event => {
    event.preventDefault()
    this.props.history.goBack()
  }

  getFormSubmitData = () => {
    let submitData = {
      type: this.state.reportType.toUpperCase(),
      year: this.state.year
    }
    switch (this.state.reportType) {
      case 'coe':
        submitData = {
          ...submitData,
          courseCode: this.props.courseCode
        }
        break
      case 'ptv':
        submitData = {
          ...submitData,
          courseCode: this.props.courseCode
        }
        break
      default:
        break
    }

    return submitData
  }

  handleOnChangeOfYears = (event, index) => {
    this.setState({
      year: event.target.value
    })
  }

  handleFormSubmit = event => {
    event.preventDefault()
    if (!this.state.submitting) {
      this.setState({
        submitting: true
      })

      putStudentReport(this.getFormSubmitData())
        .then(response => {
          if (this.state.reportType === 'coe') {
            alert('Your request for an enrolment confirmation has been submitted.')
          } else if (this.state.reportType === 'ptv') {
            alert('Your request for a PTV Tertiary Student ID has been submitted.')
          }
          this.setState({
            submitting: false
          })
        })
        .catch(error => {
          if (this.state.reportType === 'coe') {
            alert('An error occurred while processing your request for an enrolment confirmation.')
          } else if (this.state.reportType === 'ptv') {
            alert('An error occurred while processing your request for a PTV Tertiary Student ID.')
          }
          this.setState({
            submitting: false
          })
        })
    }
  }

  render() {
    if (this.state.reportType === 'coe') {
      return (
        <ConfirmationOfEnrolmentReport
          courseTitle={this.props.course.courseTitle}
          year={this.state.year}
          submit={this.handleFormSubmit}
          cancel={this.handleFormCancel}
          submitting={this.state.submitting}
          handleOnChangeOfYears={this.handleOnChangeOfYears}
        />
      )
    } else if (this.state.reportType === 'ptv') {
      return (
        <PublicTransportVictoriaReport
          personalDetails={this.props.personalDetails}
          year={this.state.year}
          submit={this.handleFormSubmit}
          cancel={this.handleFormCancel}
          submitting={this.state.submitting}
        />
      )
    }
  }
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Reports)
)
